<template>
  <div
    v-show="!hidden"
    class="update-info"    
    @wheel.stop   
    @mouseenter="$emit('diableMapDragAndZoom')"
    @mouseleave="$emit('enableMapDragAndZoom')"
  >
   <button class="close-button" @click="$emit('closeUpdateMenu')">×</button>
    <!-- 这里可以添加更新信息的内容 -->
    <div     
    @mousedown="startDrag"
    @mousemove="handleDrag"
    @mouseup="stopDrag"
    @mouseleave="stopDrag"
    class="update-title">我的申请及反馈</div>  
    <div class="update-content">
        <div class="tab-header">
            <span :class="{active:currentTab == 0}" @click="setActiveTab(0)">我的申请</span>
            <!-- <span :class="{active:currentTab == 1}" @click="setActiveTab(1)">我的审核</span> -->
            <span :class="{active:currentTab == 2}" @click="setActiveTab(2)">申请详情</span>
        </div>
        <div class="tab-content">
            <template v-if="currentTab == 0">
                <div class="button-group">
                    <label>输入关键字</label>
                    <input v-model="keywords" type="text" id="keyword_application" placeholder="输入申请关键字查询">                    
                    <label>快速查找</label>
                    <button @click="searchSH({keywords:keywords,props:[],values:[]})">全部</button>
                    <button @click="searchSH({keywords:keywords,props:['updateinfo.SHZT'],values:['审核中']})">待反馈</button>
                    <button @click="searchSH({keywords:keywords,props:['updateinfo.SHZT'],values:['已通过']})">已反馈</button>
                    <button @click="searchSH({keywords:keywords,props:['updateinfo.SHZT'],values:['未通过']})">需整改</button>
                    <label>查找结果:{{ updateinfolist?`找到${updateinfolist.data.length}条记录`:'未开始查找' }}</label>
                    <button @click="$emit('toggleUpdateStatisticDlg')">高级查找</button>
                    <button @click="refreshUpdateResults">刷新高级查找结果</button>
                    <button @click="$emit('exportToExcel',updateinfolist.data,updateinfolist.columnHeaders.columns,'审核情况.xlsx')">导出Excel</button>
                </div>
                <template v-if="updateinfolist">
                  <!-- <div class="table-form">
                    <table class="table-content">
                      <thead class="table-header">
                        <tr>
                          <th class="sticky-column-header">{{ updateinfolist.columnHeaders.firstColumnTitle }}</th>              
                          <th :class="{'sticky-column-header-2':colindex<1}" v-for="(col, colindex) in updateinfolist.columnHeaders.columns" :key="colindex">{{ col.label }}</th>
                          <th>{{ updateinfolist.columnHeaders.lastColumnTitle }}</th>
                        </tr>                        
                      </thead>
                      <tbody>
                        <tr v-for="(row,rowIndex) in updateinfolist.data" :key="rowIndex"  @mouseover="highlightRow(rowIndex)"  @mouseout="unhighlightRow(rowIndex)" :class="{ 'highlight': highlightedRow === rowIndex }">
                          <td>{{ rowIndex+1 }}</td>
                          <td v-for="(col,colIndex) in updateinfolist.columnHeaders.columns" :key="colIndex">{{col["isNum"] ? row[col.name].toFixed(2):(col.todo == 'SHZT'? shztToString(row[col.name]):(col.todo == 'SHJG'? shjgToString(row[col.name]):row[col.name])) }}</td>
                          <td style="width:60px"><a @click="positionToPatch({TCMC:row['TCMC'],WYBH:row['TBBH']})">定位</a>&nbsp;&nbsp;<a @click="showSHInfo({code:'CKSQ',TCMC:row['TCMC'],WYBH:row['WYBH']})">查看</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </div> -->
                  <div class="table-scroll-container"
                    ref="tableScrollContainer"
                    @mousedown="startTableScroll"
                    @mousemove="handleTableScroll"
                    @mouseup="stopTableScroll"
                    @mouseleave="stopTableScroll"
                  >
                    <el-table
                      :data="updateinfolist.data"
                      style="width: auto"
                      height="48vh"
                       @row-hover="handleRowHover"
                      :row-class-name="highlightedRowClass"
                      :cell-style="{textAlign:'center',fontSize:'14px'}"
                      :header-cell-style="{textAlign:'center'}"
                      fit
                      :border="true"
                      ref="tableRef"
                      @sort-change="handleSortChange"
                    >
                      <el-table-column :label="updateinfolist.columnHeaders.firstColumnTitle" :fixed="'left'" :width="80">
                        <template #default="scope">
                          {{ scope.$index + 1 }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        v-for="(col, colIndex) in updateinfolist.columnHeaders.columns"
                        :key="colIndex"
                        :prop="col.name"
                        :label="col.label"
                        :width="updateinfolist.columnWidth[colIndex]"
                        :fixed="colIndex < 2 ? 'left' : false"    
                        sortable                 
                      >
                        <template #default="scope">
                          {{
                            col.isNum
                              ? scope.row[col.name].toFixed(2)
                              : col.todo === 'SHZT'
                              ? shztToString(scope.row[col.name])
                              : col.todo === 'SHJG'
                              ? shjgToString(scope.row[col.name])
                              : scope.row[col.name]
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column :label="updateinfolist.columnHeaders.lastColumnTitle" :fixed="'right'">
                        <template #default="scope">
                          <el-link @click="positionToPatch({TCMC: scope.row.TCMC, WYBH: scope.row.TBBH})">定位</el-link>&nbsp;
                          <el-link @click="showSHInfo({code: 'CKSQ', TCMC: scope.row.TCMC, WYBH: scope.row.WYBH})">查看</el-link>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  
                </template>
                <template v-else>
                  未有审核单
                </template>
            </template>
            <template v-if="currentTab == 1">
                
            </template>
            <template v-if="currentTab == 2">
                <div v-if="localUpdateinfo" class="sh-content">   
                    <div class="sh_form_parent">            
                      <form  class="sh-form">
                        <!-- 基本信息 -->
                        <div class="info-block block-base">
                        <div class="block-title">基本信息</div>
                        <div class="form-row">
                              <label>点击定位：</label>
                              <button type="button" @click="positionToPatch({TCMC:localUpdateinfo.TCMC,WYBH:localUpdateinfo.TBBH})">定位</button>
                          </div>
                          <div class="form-row">
                              <label>当前反馈状态：</label>   
                              <label>{{ localUpdateinfo.shzt==0?"新提交申请":shztToString(localUpdateinfo.SHZT) }} </label>
                          </div>
                          <div class="form-row">
                              <label>基本信息：</label>   
                              <label>面积：{{ localUpdateinfo.Area==null?"未查到":localUpdateinfo.Area.toFixed(2) }}亩,2024年地类: {{ localUpdateinfo.DL2024 == null?"未知":localUpdateinfo.DL2024 }} ,2025年地类: {{ localUpdateinfo.DL2025 == null?"未知":localUpdateinfo.DL2025 }}</label>
                          </div>
                          <!-- 非农化处置信息：仅当一级分类为非农化时显示 -->
                          <template v-if="localUpdateinfo.YJFL == '非农化'">
                            <div class="form-row">
                                <label>{{ fnczYjflLabel }}：</label>
                                <label>{{ localUpdateinfo.FNCZYJFL || '未设定' }}</label>
                            </div>
                            <div class="form-row">
                                <label>{{ fnczEjflLabel }}：</label>
                                <label>{{ localUpdateinfo.FNCZEJFL || '未设定' }}</label>
                            </div>
                            <div class="form-row">
                                <label>{{ fnczBcyjLabel }}：</label>
                                <label>{{ localUpdateinfo.FNCZBCYJ || '' }}</label>
                            </div>
                            <div v-if="roleType == 'ZFD'" class="form-row">
                                <label>非农化处置：</label>
                                <button type="button" @click="openFnczDialog">设定</button>
                            </div>
                          </template>
                          <div class="form-row">
                              <label for = "WYBH">申请编号：</label>
                              <input v-model="localUpdateinfo.WYBH" type="text" id="WYBH" name="WYBH" readonly>
                          </div>
                          <div class="form-row">
                              <label for = "TBBH">图斑编号：</label>
                              <input v-model="localUpdateinfo.TBBH" type="text" id="TBBH" name="TBBH" readonly>
                          </div>
                          <div class="form-row">
                              <label for = "ZJ">镇街：</label>
                              <input v-model="localUpdateinfo.ZJ" type="text" id="ZJ" name="ZJ" readonly>
                          </div>
                          <div class="form-row">
                              <label for = "TCMC">图层名称：</label>
                              <input v-model="localUpdateinfo.TCMC" type="text" id="TCMC" name="TCMC" readonly>
                          </div>
                          <div class="form-row">
                              <label for = "TCJC">图层简称：</label>
                              <input v-model="localUpdateinfo.TCJC" type="text" id="TCJC" name="TCJC" readonly>
                          </div>
                          <div class="form-row">
                              <label for = "WTMS">问题描述：</label>
                              <input v-model="localUpdateinfo.WTMS" type="text" id="WTMS" name="WTMS" readonly>
                          </div>
                        </div>
                        <!-- 镇街提交信息 -->
                        <div class="info-block block-zj">
                        <div class="block-title">镇街提交信息</div>
                          <div class="form-row">
                              <label for = "SFZZ">当前是否种植：</label>
                              <select v-model="localUpdateinfo.SFZZ" id="SFZZ" name="SFZZ"  :disabled="localUpdateinfo.shzt > 0">
                                  <option value="正常种植">正常种植</option>
                                  <option value="未种植">未种植</option>
                                  <option value="未正常种植">未正常种植</option>
                              </select>                            
                          </div>
                          <div class="form-row">
                              <label for = "ZZTJ">是否具备种植条件：</label>
                              <select v-model="localUpdateinfo.ZZTJ" id="ZZTJ" name="ZZTJ" :disabled="localUpdateinfo.shzt > 0">
                                  <option value="是">是</option>
                                  <option value="否">否</option>
                              </select>                            
                          </div>
                          <div class="form-row">                            
                              <label for = "ZGJG">整改结果：</label>
                              <select v-model="localUpdateinfo.ZGJG" id="ZGJG" name="ZGJG" :disabled="localUpdateinfo.shzt > 0">
                                  <option value="整改中">整改中</option>
                                  <option value="已整改">已整改</option>
                                  <option value="拟挂账">拟挂账</option>
                              </select>                           
                          </div>  
                          <div class="form-row">                            
                              <label for = "BCSM">补充说明：</label>
                              <textarea v-model="localUpdateinfo.BCSM" type="text" id="BCSM" name="BCSM" :disabled="localUpdateinfo.shzt > 0" style="height: 50px;"></textarea>                                              
                          </div>                       
                          <!--0未提交 1审核中 2已通过 3未通过 -->
                          <div v-if="localUpdateinfo.shzt > 0" class="form-row">
                              <label for = "TJRQ">提交日期：</label>
                              <input v-model="localUpdateinfo.TJRQ" type="text" id="TJRQ" name="TJRQ" readonly>
                          </div>
                          <div v-if="localUpdateinfo.shzt > 0" class="form-row">
                              <label for = "TJRY">提交人员：</label>
                              <input v-model="localUpdateinfo.TJRY" type="text" id="TJRY" name="TJRY" readonly>
                          </div>
                        </div>
                        <!-- 部门审核信息 -->
                        <div v-if="localUpdateinfo.shzt > 0" class="info-block block-sh">
                          <div class="block-title">部门审核信息</div>
                            <div class="form-row">                            
                              <label>各方建议：</label>
                              <div class="sh-option-container">      
                                <div class="sh-text">▶【图斑状态】({{shztToString(localUpdateinfo.SHZT) }})({{ updateinfo.YYFL ||'空' }})</div>                        
                                <div class="sh-text">▶【农业农村局】({{ updateinfo.SHZT_NCJ ||'未提交' }}){{ updateinfo.SHYJ_NCJ ||'' }}(日期：{{updateinfo.SHRQ_NCJ||'空'}})</div>
                                <div class="sh-text">▶【规自昌平分局】({{ updateinfo.SHZT_GZ ||'未提交' }}){{ updateinfo.SHYJ_GZ ||'' }}(日期：{{updateinfo.SHRQ_GZ||'空'}})</div>
                                <div class="sh-text">●【执法队】({{ updateinfo.SHZT_ZFD ||'未提交' }}){{ updateinfo.SHYJ_ZFD ||'' }}(日期：{{updateinfo.SHRQ_ZFD||'空'}})</div>
                                <div class="sh-text">●【保护科】({{ updateinfo.SHZT_GBK ||'未提交' }}){{ updateinfo.SHYJ_GBK ||'' }}(日期：{{updateinfo.SHRQ_GBK||'空'}})</div>
                                <div class="sh-text">●【监测科】({{ updateinfo.SHZT_JCK ||'未提交' }}){{ updateinfo.SHYJ_JCK ||'' }}(日期：{{updateinfo.SHRQ_JCK||'空'}})</div>
                                <div class="sh-text">●【测绘院】({{updateinfo.STATE_CHY > 0 ? updateinfo.SHZT_CHY :'未提交'}}){{ updateinfo.STATE_CHY > 0 ? updateinfo.SHYJ_CHY :'' }}(日期：{{updateinfo.STATE_CHY > 0 ? updateinfo.SHRQ_CHY :'空'}}){{ updateinfo.STATE_CHY==1?"(保存)":updateinfo.STATE_CHY==2?"(提交)":"" }}{{ updateinfo.XTRD ? `(${updateinfo.XTRD})` :"" }}</div>
                              </div>                          
                            </div>

                            <template v-if="['ZFD','GBK','JCK','NCJ','CHY'].includes(roleType)">                            

                              <div class="form-row">
                                  <label for = "SHJG">我的建议{{ `(${roleTypeToString(roleType)})` }}</label>
                                  <select v-model="SHYJ.SHZT" id="SHJG" name="SHJG" :disabled="localUpdateinfo.shzt > 1">
                                      <option value="已通过">无建议</option>
                                      <option value="未通过">有建议</option>
                                  </select>
                              </div>
                              <div class="form-row">
                                  <label for = "YYFL">原因分类</label>
                                  <select v-model="SHYJ.YYFL" id="YYFL" name="YYFL" :disabled="SHYJ.SHZT!='未通过'">
                                      <option value="撂荒">撂荒</option>
                                      <option value="部分种植">部分种植</option>
                                      <option value="未种植">未种植</option>
                                      <option value="非地表种植">非地表种植</option>
                                      <option value="树木">树木</option>
                                      <option value="堆物堆放">堆物堆放</option>
                                      <option value="道路">道路</option>
                                      <option value="重新举证">重新举证</option>
                                      <option value="其它">其它</option>
                                  </select>
                              </div>
                              <div v-if="roleType == 'CHY'" class="form-row">                            
                                <label for = "WYFH">外业复核：</label>
                                <select v-model="localUpdateinfo.WYFH" id="WYFH" name="WYFH" :disabled="localUpdateinfo.shzt > 1">
                                    <option value=0>未选择</option>
                                    <option value=1>无需外业</option>
                                    <option value=2>需要外业</option>
                                    <option value=3>外业完成</option>
                                </select>   
                                <label for = "XTRD">协同认定：</label>
                                <select v-model="localUpdateinfo.XTRD" id="XTRD" name="XTRD" :disabled="localUpdateinfo.shzt > 1">
                                    <option value=''>不需要</option>
                                    <option value='协同认定'>协同认定</option>
                                </select>                           
                              </div>   
                              <div class="form-row">
                                  <label for = "SHYY">具体建议：</label>
                                  <textarea v-model="SHYJ.SHYJ" type="text" id="SHYY" name="SHYY" :readonly="localUpdateinfo.shzt>1" style="height: 100px;"> </textarea>
                              </div> 
                              <div v-if="localUpdateinfo.shzt==1 && (role=='admin' || role=='superadmin')" class="form-row">
                                  <label>复核照片(可选)：</label>
                                  <input type="file" @change="uploadFHImages" accept="image/*" multiple>
                              </div> 
                            </template>                
                        </div>
                        <!-- 反馈记录 -->
                        <div class="info-block block-record">
                        <div class="block-title">反馈记录</div>
                          <div class="form-row">
                              <label for = "BZ">反馈记录：</label> 
                              <textarea v-model="localUpdateinfo.BZ" type="text" id="BZ" name="BZ" readonly style="height: 300px;"></textarea>
                          </div>
                        </div>
                          
                          <div v-if="localUpdateinfo.IsEditable > 0" class="form-row">
                              <button v-if="localUpdateinfo.shzt==0 && roleType=='ZJ'" type="button" @click="submitSHZT(1)">保存(暂不提交)</button>
                              <button v-if="localUpdateinfo.shzt==0 && roleType=='ZJ'" type="button" @click="submitSHZT(2)">保存并提交申请</button>
                              <button v-if="localUpdateinfo.shzt==1 && roleType == 'CHY'" type="button" @click="submitSHZT(1)">保存建议(暂不审核)</button>
                              <button v-if="localUpdateinfo.shzt==1 && (role=='admin' || role=='superadmin')" type="button" @click="submitSHZT(2)">填写建议(审核)</button>
                              <button v-if="localUpdateinfo.shzt==2 && (role=='superadmin')" type="button" @click="submitSHZT()">驳回申请</button>                           
                          </div>
                      </form>  
                      <template v-if="roleType == 'GBK'">
                          <el-collapse>
                              <el-collapse-item title="系统设定(该部分设定不进入审核流程，直接确认结果)">
                                <div class="sh-form">
                                  <div class="form-row">
                                    <label for = "SYSSHZT">系统设定</label>
                                    <select v-model="sysSet.SHZT" id="SYSSHZT" name="SYSSHZT">
                                        <option value="已通过">通过</option>
                                        <option value="未通过">未通过</option>
                                        <option value="挂账">挂账</option>
                                    </select>
                                  </div>
                                  <div class="form-row">
                                    <label for = "SYSYYFL">原因分类</label>
                                    <select v-model="sysSet.YYFL" id="SYSYYFL" name="SYSYYFL" :disabled="sysSet.SHZT!='未通过'">
                                        <option value="撂荒">撂荒</option>
                                        <option value="部分种植">部分种植</option>
                                        <option value="未种植">未种植</option>
                                        <option value="非地表种植">非地表种植</option>
                                        <option value="树木">树木</option>
                                        <option value="堆物堆放">堆物堆放</option>
                                        <option value="道路">道路</option>
                                        <option value="重新举证">重新举证</option>
                                        <option value="其它">其它</option>
                                    </select>
                                  </div>
                                  <div class="form-row">
                                      <label for = "SYSSHYY">具体建议：</label>
                                      <textarea v-model="sysSet.SHYY" type="text" id="SYSSHYY" name="SYSSHYY"  style="height: 100px;"> </textarea>
                                  </div> 
                                  <div class="form-row">
                                      <button type="button" @click="submitSYSSet()">系统设定</button>
                                      <button type="button" @click="submitBHKYJ()">补充为保护科意见</button>
                                  </div> 
                                </div>                                  
                              </el-collapse-item>
                          </el-collapse>
                      </template>    
                    </div>              
                    <div class="sh-pic-content">
                        <div v-if="localUpdateinfo.shzt === 0" class="sh-pic-content-button">
                            <input type="file" @change="handleFileSelect" accept="image/*" multiple>
                            <button @click="uploadImages">上传照片</button>
                        </div>
                        
                        <div>
                            <h3>镇街反馈照片</h3>
                            <div v-for="(img, index) in previewImages" :key="index" >
                                <img :src="img" alt="照片预览" async class="preview-image" @click="toggleZoom(img)">                                
                            </div>
                            <h3>现场复核照片</h3>
                            <div v-for="(img, index) in fhImages" :key="index" >
                                <img :src="img" alt="照片预览" async class="preview-image" @click="toggleZoom(img)">
                            </div>
                            <h3>日常巡查照片</h3>
                            <div v-for="(img, index) in xcImages" :key="index" >
                                <img :src="img" alt="照片预览" async class="preview-image" @click="toggleZoom(img)">
                            </div>
                        </div>   
                    </div>
                </div>
                <div v-else>
                    请先选择要查看的申请.
                </div>
                <div v-if="currentZoomedPhoto" class="zoom-overlay" @click="toggleZoom(null)" >
                    <img :src="currentZoomedPhoto" alt="照片预览" style="width: 100%;height: 100%;object-fit: contain;">
                </div>  
            </template>            
        </div>
    </div>
    <!-- 非农化处置设定对话框 -->
    <FnczSetDialog :visible="isFnczDialogVisible" :patch="updateinfo" :config="fnczConfig"
      @close="isFnczDialogVisible = false" @confirm="onFnczConfirm" />
  </div>
</template>

<script>
import {ElTable,ElTableColumn, ElLink } from 'element-plus';
import FnczSetDialog from './FnczSetDialog.vue';
export default {
  components: {
    ElTable,
    ElTableColumn,
    ElLink,
    FnczSetDialog
  },
  props: {
    hidden: {
      type: Boolean,
      default: false,
    },
    updateinfo:{
      type:Object,
      default:null,
      //shzt:0, //审核状态 0未提交，1审核中，2已通过，3未通过
    },
    roleType:{ //用户角色类型
      type:String,
      default:'',
    },
    updateinfolist:null,   
    serverAddress:{ //服务地址
      type:String,
      default:'',
    },
    updateConditions:{  //高级查找条件
      type:Object,
      default:null,
    },
    fnczConfig:{  //非农化处置配置（来自tableConfig/wthz.json）
      type:Object,
      default:null,
    }
  },
  name: 'UpdateInfo',
  data() {
    return {   
      highlightedRow: null,   
      isDragging: false,
      startX: 0,
      startY: 0,
      offsetX: 0,
      offsetY: 0,
      currentTab: 0, //当前活动Tab的索引   
      selectedFiles: null, // 存储选择的文件 
      previewImages: null, // 存储预览的图片数据 
      fhImages:null, //复核照片数据 
      xcImages:null, //日常巡查照片数据
      // 记录当前放大的照片
      currentZoomedPhoto: null, 
      isFnczDialogVisible:false, //非农化处置设定对话框是否显示
      role:localStorage.getItem('role') || '', //用户角色
      keywords:'',//搜索关键字
      SHYJ:{  //审核意见
        WYBH:'',
        roleType:'',
        SHZT:'已通过',
        SHYJ:'无建议',
        YYFL:'',
        SHRQ:'',
        SHRY:'',
        XTRD:'', //协同认定
      },
      sysSet:{ //统一设定
        SHZT:'已通过',
        SHYY:'无建议',
        YYFL:'',
        SHRQ:'',
        SHRY:''
      },
      isScrolling: false,
      scrollStartX: 0,
      startScrollLeft: 0,
      sortColumn: '',
      sortDirection: '',
    };
  }, 
  computed:{
    localUpdateinfo(){             
        return this.updateinfo;
    },
    fnczYjflLabel(){ //非农处置一级分类标签，取自配置
      return (this.fnczConfig && this.fnczConfig.yjflLabel) || '非农处置一级分类';
    },
    fnczEjflLabel(){
      return (this.fnczConfig && this.fnczConfig.ejflLabel) || '非农处置二级分类';
    },
    fnczBcyjLabel(){
      return (this.fnczConfig && this.fnczConfig.bcyjLabel) || '非农处置补充意见';
    },
  },  
  watch:{
    'SHYJ.SHZT'(newVal){
      if(newVal == '已通过'){
        this.SHYJ.YYFL = '';
      }else{
        this.SHYJ.YYFL = '';
      }
    },
    'sysSet.SHZT'(newVal){
      if(newVal == '已通过' || newVal == '挂账'){
        this.sysSet.YYFL = '';
      }else{
        this.sysSet.YYFL = '';
      }
    },
    updateinfo(newVal){      
      if(newVal){ 
        this.resetCurrSHYJ();
        this.resetPhotos();   
      //     // this.$emit('getPatchAllPhotoDataCallback',{TCMC:newVal.TCMC,WYBH:newVal.TBBH},(files)=>{
      //     //   let fkImgs = [];
      //     //   let fhImgs = [];
      //     //   if(files.fkPhotos && files.fkPhotos.length > 0){
      //     //     files.fkPhotos.forEach(photo=>{
      //     //       fkImgs.push(`${this.serverAddress}/photos/${newVal.TCMC}/图斑照片/${newVal.TBBH}/反馈照片/${photo}`);
      //     //     });
      //     //   }
      //     //   if(files.fhPhotos && files.fhPhotos.length > 0){
      //     //     files.fhPhotos.forEach(photo=>{
      //     //       fhImgs.push(`${this.serverAddress}/photos/${newVal.TCMC}/图斑照片/${newVal.TBBH}/复核照片/${photo}`);
      //     //     });
      //     //   }  
      //     //   this.previewImages = fkImgs;
      //     //   this.fhImages = fhImgs;  
      //     // });            
      //     // let TJZP = newVal.TJZP?newVal.TJZP.split(';'):[];
      //     // if(TJZP && TJZP.length > 0){
      //     //    let imgs = [];
      //     //    for(let i = 0; i < TJZP.length; i++){
      //     //     imgs.push(`${this.serverAddress}/photos/${newVal.TCMC}/图斑照片/${newVal.TBBH}/${TJZP[i]}`);
      //     //    }
      //     //    this.previewImages = imgs; 
      //         //console.log(this.previewImages);
      }else{
        this.selectedFiles = null;  
        this.previewImages = null;
        this.fhImages = null;
      } 
    }
  },
  
  methods: {  
   startTableScroll(event) {
      this.isScrolling = true
      this.scrollStartX = event.pageX
      this.startScrollLeft = this.$refs.tableScrollContainer.scrollLeft
    },
    handleTableScroll(event) {
      if (this.isScrolling) {
        const deltaX = event.pageX - this.scrollStartX
        this.$refs.tableScrollContainer.scrollLeft = this.startScrollLeft - deltaX
      }
    },
    stopTableScroll() {
      this.isScrolling = false
    },
    highlightedRowClass({ rowIndex }) {
      return this.highlightedRow === rowIndex ? 'highlight' : ''
    },
    handleRowHover(row, event) {
      console.log("here1");
      if (event.type === 'mouseover') {
        console.log('鼠标移入行', row)
        const table = this.$refs.tableRef
        if (table) {
          const rows = table.store.states.data
          const rowIndex = rows.indexOf(row)
          if (rowIndex > -1) {
            this.highlightedRow = rowIndex
          } else {
            console.error('未找到行索引', row)
          }
        } else {
          console.error('表格组件引用失败，无法获取行索引')
        }
      } else if (event.type === 'mouseout') {
        console.log('鼠标移出行')
        this.highlightedRow = null
      }
    },
    highlightRow(rowIndex) {
      console.log("here");
      this.highlightedRow = rowIndex
    },
    unhighlightRow() {
      this.highlightedRow = null
    },

    roleTypeToString(roleType){
      switch(roleType){
        case 'ZJ':
          return '镇街';
        case 'DSF':
          return '第三方'; 
        case 'NCJ':
          return '农村局'; 
        case 'ZFD':
          return '执法队';
        case 'GBK':
          return '耕保科'; 
        case 'JCK':
          return '监测科'; 
        case 'GZ':
          return '规自分局';
        case 'CHY':
          return '测绘院';
        default:
          return '其他';  
      } 
    },

    resetPhotos(){ //重置照片
      let TCMC = this.updateinfo.TCMC;
      let WYBH = this.updateinfo.TBBH;
      this.$emit('getPatchAllPhotoDataCallback',{TCMC:TCMC,WYBH:WYBH},(files)=>{
        let fkImgs = [];
        let fhImgs = [];
        let xcImgs = [];
        if(files.fkPhotos && files.fkPhotos.length > 0){
          files.fkPhotos.forEach(photo=>{
            fkImgs.push(`${this.serverAddress}/photos/${TCMC}/图斑照片/${WYBH}/反馈照片/${photo}`);
          });
        }
        if(files.fhPhotos && files.fhPhotos.length > 0){
          files.fhPhotos.forEach(photo=>{
            fhImgs.push(`${this.serverAddress}/photos/${TCMC}/图斑照片/${WYBH}/复核照片/${photo}`);
          });
        }
        if(files.xcPhotos && files.xcPhotos.length > 0){
          files.xcPhotos.forEach(photo=>{
            xcImgs.push(`${this.serverAddress}/photos/${TCMC}/图斑照片/${WYBH}/巡查照片/${photo}`);
          });
        }  
        this.previewImages = fkImgs;
        this.fhImages = fhImgs;  
        this.xcImages = xcImgs;
      }); 
    },

    resetUpdatePreviewImages(){  //重置上传图片      
        if(this.updateinfo && this.updateinfo.TJZP){
            let TJZPs = this.updateinfo.TJZP.split(';');
            if(TJZPs && TJZPs.length > 0){
                let imgs = [];
                for(let i = 0; i < TJZPs.length; i++){
                    imgs.push(`${this.serverAddress}/photos/${this.updateinfo.TCMC}/图斑照片/${this.updateinfo.TBBH}/反馈照片/${TJZPs[i]}`);
                }
                this.previewImages = imgs; 
                //console.log(this.previewImages);
            }
        }else{
            this.previewImages = null;
            this.selectedFiles = null;
        }
    },



    openFnczDialog(){ //打开非农化处置设定对话框
      this.isFnczDialogVisible = true;
    },

    onFnczConfirm(form){ //确定非农化处置设定，交由父组件保存
      this.isFnczDialogVisible = false;
      let info = this.localUpdateinfo;
      this.$emit('saveFnczSet',{
        TCMC: info ? info.TCMC : '',
        WYBH: info ? info.TBBH : '',
        FNCZYJFL: form.FNCZYJFL,
        FNCZEJFL: form.FNCZEJFL,
        FNCZBCYJ: form.FNCZBCYJ,
      });
    },

    toggleZoom(photo) {
      this.currentZoomedPhoto = photo === this.currentZoomedPhoto ? null : photo;
    },

    setActiveTab(index) {
      this.currentTab = index; //设置当前活动Tab的索引
      if(index === 2){
        this.resetCurrSHYJ();
      } 
    },

    getSHYJ(roleType){  //获取审核意见
      switch(roleType){
       case 'GBK':
          return {
            SHYJ:this.updateinfo.SHYJ_GBK || '无意见',
            SHRQ:this.updateinfo.SHRQ_GBK || '',
            SHRY:this.updateinfo.SHRY_GBK || '', 
            SHZT:this.updateinfo.SHZT_GBK || '已通过',
            WYBH:this.updateinfo.WYBH,
            roleType:this.roleType,
          };           
       case 'NCJ':
          return {
            SHYJ:this.updateinfo.SHYJ_NCJ || '无意见',
            SHRQ:this.updateinfo.SHRQ_NCJ || '',
            SHRY:this.updateinfo.SHRY_NCJ || '',
            SHZT:this.updateinfo.SHZT_NCJ || '已通过',
            WYBH:this.updateinfo.WYBH,
            roleType:this.roleType,
          };
       case 'ZFD':
          return {
            SHYJ:this.updateinfo.SHYJ_ZFD || '无意见',
            SHRQ:this.updateinfo.SHRQ_ZFD || '',
            SHRY:this.updateinfo.SHRY_ZFD || '',
            SHZT:this.updateinfo.SHZT_ZFD || '已通过',
            WYBH:this.updateinfo.WYBH,
            roleType:this.roleType,
          };
       case 'JCK':
          return {
            SHYJ:this.updateinfo.SHYJ_JCK || '无意见',
            SHRQ:this.updateinfo.SHRQ_JCK || '',
            SHRY:this.updateinfo.SHRY_JCK || '',
            SHZT:this.updateinfo.SHZT_JCK || '已通过',
            WYBH:this.updateinfo.WYBH,
            roleType:this.roleType,
          };
       case 'GZ':
          return {
            SHYJ:this.updateinfo.SHYJ_GZ || '无意见',
            SHRQ:this.updateinfo.SHRQ_GZ || '',
            SHRY:this.updateinfo.SHRY_GZ || '',
            SHZT:this.updateinfo.SHZT_GZ || '已通过',
            WYBH:this.updateinfo.WYBH,
            roleType:this.roleType,
          }; 
      case 'CHY':
          return {
            SHYJ:this.updateinfo.SHYJ_CHY || '无意见',
            SHRQ:this.updateinfo.SHRQ_CHY || '',
            SHRY:this.updateinfo.SHRY_CHY || '',
            SHZT:this.updateinfo.SHZT_CHY || '已通过',
            WYBH:this.updateinfo.WYBH,
            roleType:this.roleType,
          }; 
        default:
          return {
            SHYJ:'无意见',
            SHRQ:'',
            SHRY:'',
            SHZT:'已通过',
            WYBH:this.updateinfo.WYBH,
            roleType:this.roleType,
          };
      }
    },
    

    resetCurrSHYJ(){  //重置审核意见
      if(this.localUpdateinfo){        
        this.SHYJ =  this.getSHYJ(this.roleType);
      }
    },

    startDrag(event) {
      event.stopPropagation();
      this.isDragging = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
      if (this.$el) {
        this.offsetX = this.$el.offsetLeft;
        this.offsetY = this.$el.offsetTop;        
        document.addEventListener('mousemove', this.drag);
        document.addEventListener('mouseup', this.stopDrag);
      }
    },
    drag(event) {
      event.stopPropagation();
      if (this.isDragging && this.$el) {
        const dx = event.clientX - this.startX;
        const dy = event.clientY - this.startY;
        if (this.$el.style) {
          this.$el.style.left = `${this.offsetX + dx}px`;
          this.$el.style.top = `${this.offsetY + dy}px`;
        }
      }
    },
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.drag);
      document.removeEventListener('mouseup', this.stopDrag);      
    },

    async submitSYSSet(){
      try {
        await this.$confirm('确定要提交系统设定吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        this.sysSet.SHRQ = this.formatDate(new Date());
        this.sysSet.SHRY = localStorage.getItem("userName");
        this.sysSet.TCMC = this.localUpdateinfo.TCMC;
        this.sysSet.TBBH = this.localUpdateinfo.TBBH;
        this.sysSet.WYBH = this.localUpdateinfo.WYBH;
        this.$emit('submitSysSet',this.sysSet);
      } catch {
        // 用户点击取消，不执行任何操作
      }
    },

    async submitBHKYJ(){
      try {
        await this.$confirm('确定要提交保护科意见吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        this.sysSet.SHRQ = this.formatDate(new Date());
        this.sysSet.SHRY = localStorage.getItem("userName");
        this.sysSet.TCMC = this.localUpdateinfo.TCMC;
        this.sysSet.TBBH = this.localUpdateinfo.TBBH;
        this.sysSet.WYBH = this.localUpdateinfo.WYBH;
        this.$emit('submitBHKYJ',this.sysSet);
      } catch {
        // 用户点击取消，不执行任何操作
      }
    },
    submitSHZT(state = 2){
        if(this.localUpdateinfo){
            if(this.localUpdateinfo.shzt == 0){//提交请求
                if(this.localUpdateinfo.ZGJG == '' || this.localUpdateinfo.SFZZ == '' || this.localUpdateinfo.ZZTJ == ''){
                    this.$emit('showMsgBox',{title:'提示',isMsgBoxHidden:false,msg:'整改结果、是否种植、是否具备种植条件不能为空',state:'warning',buttons:'ok'});
                  //alert('整改结果、是否种植、是否具备种植条件不能为空');
                }else{
                    // let TJZP = "";
                    // if(this.selectedFiles && this.selectedFiles.length > 0){
                    //     TJZP = this.selectedFiles.map((file,index) => `${this.updateinfo.WYBH}_${index+1}.jpg`).join(';');
                    // }
                    if(this.localUpdateinfo.ZGJG == '拟挂账'){
                      if(!this.localUpdateinfo.BCSM || this.localUpdateinfo.BCSM.length < 3){
                        this.$emit('showMsgBox',{title:'提示',isMsgBoxHidden:false,msg:'请填写拟挂账补充说明！',state:'warning',buttons:'ok'});
                        return;
                      }
                    }


                    if(this.localUpdateinfo.TJZP == "" &&  this.selectedFiles && this.selectedFiles.length > 0){
                        this.$emit('showMsgBox',{title:'提示',isMsgBoxHidden:false,msg:'请先上传照片！',state:'warning',buttons:'ok'});
                        return;
                    }
                    //this.localUpdateinfo.TJZP = TJZP;
                    this.localUpdateinfo.TJRQ = this.formatDate(new Date());
                    this.localUpdateinfo.TJRY = localStorage.getItem("userName");
                    this.localUpdateinfo.STATE_ZJ = state;
                    this.$emit('submitApplication',{updateInfo:this.localUpdateinfo});                    
                }
            }else if(this.localUpdateinfo.shzt == 1){//提交审核
                // if(this.localUpdateinfo.SHJG == '' || this.localUpdateinfo.SHJG == null){
                //     this.$emit('showMsgBox',{title:'提示',isMsgBoxHidden:false,msg:'反馈结果不能为空',state:'warning',buttons:'ok'}); 
                //     return;
                // }
                // if(this.localUpdateinfo.SHJG == '未通过' && this.localUpdateinfo.SHYY == ''){
                //     this.$emit('showMsgBox',{title:'提示',isMsgBoxHidden:false,msg:'请填反馈意见！',state:'warning',buttons:'ok'});
                //     return; 
                // }
                // this.localUpdateinfo.SHRY = localStorage.getItem("userName");
                // this.localUpdateinfo.SHRQ = new Date().toLocaleString();
                // this.localUpdateinfo.BZ = this.localUpdateinfo.BZ + `{${this.localUpdateinfo.SHRY}:${this.localUpdateinfo.SHRQ}:${this.localUpdateinfo.SHJG}:${this.localUpdateinfo.SHYY}}`;
                // this.$emit('submitExamine',{updateInfo:this.localUpdateinfo});
                if(this.SHYJ.SHZT == '' || this.SHYJ.SHZT == null || this.SHYJ.SHZT == '未提交'){
                    this.$emit('showMsgBox',{title:'提示',isMsgBoxHidden:false,msg:'反馈结果不能为空',state:'warning',buttons:'ok'}); 
                    return;
                }
                if(this.SHYJ.SHZT == '未通过' && this.SHYJ.YYFL == ''){
                    this.$emit('showMsgBox',{title:'提示',isMsgBoxHidden:false,msg:'请填未通过原因分类！',state:'warning',buttons:'ok'}); 
                    return;
                }
                // console.log(this.SHYJ);
                this.SHYJ.TBBH = this.localUpdateinfo.TBBH;
                this.SHYJ.TCMC = this.localUpdateinfo.TCMC;
                this.SHYJ.WYBH = this.localUpdateinfo.WYBH;
                this.SHYJ.roleType = this.roleType;
                this.SHYJ.SHRQ = this.formatDate(new Date());
                this.SHYJ.SHRY = localStorage.getItem("userName");
                if(this.roleType == 'CHY'){
                  this.SHYJ.STATE_CHY = state;
                  this.SHYJ.WYFH = this.localUpdateinfo.WYFH;  
                  this.SHYJ.XTRD = this.localUpdateinfo.XTRD || '';
                } 
                this.$emit('submitExamine',{shyj:this.SHYJ});
            }else if(this.localUpdateinfo.shzt == 2){//驳回申请
                this.$emit('executeSHByCode',{code:'BHSQ',TCMC:this.localUpdateinfo.TCMC,WYBH:this.localUpdateinfo.WYBH});
            }            
        }
    },

    async handleFileSelect(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        let imgs = [];
        let sfiles = [];
        let selectedFiles = Array.from(files);
        this.localUpdateinfo.TJZP = '';

        const readPromises = selectedFiles.map(file => {
          return new Promise((resolve, reject) => {
            sfiles.push(file);
            const reader = new FileReader();
            reader.onload = (e) => {
              resolve(e.target.result);
            };
            reader.onerror = (e) => {
              reject(e);
            };
            reader.readAsDataURL(file);
          });
        });

        try {
          const results = await Promise.all(readPromises);
          results.forEach(result => {
            imgs.push(result);
          })
          this.previewImages = imgs;
          this.selectedFiles = sfiles;
                
        } catch (error) {
          console.error('读取文件时出现错误:', error);
        }
      }
    },
    uploadImages(){  //上传照片
        if(this.selectedFiles && this.selectedFiles.length > 0){
            this.$emit('showMsgBox',{title:'提示',isMsgBoxHidden:false,msg:'正在上传中。。。',state:'loading',buttons:'ok'});
            this.$emit('uploadImagesCallback',{files:this.selectedFiles,TBBH:this.updateinfo.TBBH},(msg)=>{
                if(msg.code === 0){  //上传成功！
                    if(this.selectedFiles){
                        this.localUpdateinfo.TJZP = msg.data.join(';');
                    }                    
                    this.$emit('showMsgBox',{title:'提示',isMsgBoxHidden:false,msg:msg.msg,state:'success',buttons:'ok'});
                }else{ //上传失败！
                    this.$emit('showMsgBox',{title:'提示',isMsgBoxHidden:false,msg:msg.msg,state:'error',buttons:'ok'});
                }
            });
        }
    },

    async uploadFHImages(event){
      const files = event.target.files;
      if (files && files.length > 0) {       
        let sfiles = [];
        let selectedFiles = Array.from(files);
        this.localUpdateinfo.TJZP = '';

        const readPromises = selectedFiles.map(file => {
          return new Promise((resolve, reject) => {
            sfiles.push(file);
            const reader = new FileReader();
            reader.onload = (e) => {
              resolve(e.target.result);
            };
            reader.onerror = (e) => {
              reject(e);
            };
            reader.readAsDataURL(file);
          });
        });

        try {
          await Promise.all(readPromises);
          this.$emit('showMsgBox',{title:'提示',isMsgBoxHidden:false,msg:'正在上传中。。。',state:'loading',buttons:'ok'});
          this.$emit('uploadFHImagesCallback',{files:sfiles,TBBH:this.updateinfo.TBBH,TCMC:this.updateinfo.TCMC},(msg)=>{
            if(msg.code === 0){  //上传成功！
                this.fhImages = msg.data;             
                this.$emit('showMsgBox',{title:'提示',isMsgBoxHidden:false,msg:msg.msg,state:'success',buttons:'ok'});
            }else{ //上传失败！
                this.$emit('showMsgBox',{title:'提示',isMsgBoxHidden:false,msg:msg.msg,state:'error',buttons:'ok'});
            }
            });
          this.selectedFiles = sfiles;
                
        } catch (error) {
          console.error('读取文件时出现错误:', error);
        }
      }
    },

    searchSH(params){  //查找符合条件的审核记录
      this.$emit('searchSHByCondition',params);
    },

    positionToPatch(params){
      this.$emit('closeUpdateMenu');
      this.$emit('positionToPatch',params);
    },

    showSHInfo(params){
      this.$emit('executeSHByCode',params);
    },
    shztToString(shzt){
      switch(shzt){
        case '审核中':
          return '待反馈';
        case '已通过':
          return '已反馈';
        case '未通过':
          return '需整改';
        default:
          return shzt;
      } 
    },

    shjgToString(shjg){
      switch(shjg){
        case '已通过':
          return '无建议';
        case '未通过':
          return '需整改';
        default:
          return shjg;
      }
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
    },  
    handleSortChange(column) {
      this.sortColumn = column.prop;
      this.sortDirection = column.order === 'ascending' ? 'asc' : 'desc';
      //console.log(column,this.sortColumn,this.sortDirection);
      this.$emit('sortUpdateInfoListData',this.sortColumn,this.sortDirection);
    },  
    refreshUpdateResults(){
      if(this.updateConditions){
        this.$emit('searchUpdateStatistic',this.updateConditions);
      }      
    }, 
  }
};
</script>

<style scoped>
.update-info {
  position: fixed;
  width: 80vw;
  top: 20vh;   
  left: 10vw;
  height: 60vh;
  display: flex;
  flex-direction: column;
  background-color: #f4f4f4;
  padding: 10px;
  z-index: 1003;
  border: 1px solid #292541;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.update-title {
  background-color: #e0e0e0; /* 标题栏背景颜色 */
  padding: 5px;
  margin: -10px -10px 10px -10px; /* 调整标题栏的边距 */
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  position:relative;
  top:0;
  z-index: 1003;
  cursor: move;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 20px;
  cursor: pointer;
  z-index: 1004;
}

.table-scroll-container {
  overflow-x: auto; /* 启用水平滚动 */
  max-width: 100%; /* 最大宽度不超过父容器 */
}

.update-content{
  display:flex;
  height: 95%;
}

.tab-header {
  display: flex;
  border: 1px solid #ccc;
  flex-direction: column;
  margin:5px;
  height:95%;
}

.tab-header span {
  padding: 10px 20px;
  cursor: pointer;
  background-color: #f0f0f0;
  color:black; 
  border: 1px solid #555;
  margin: 1px;
}

.tab-header span.active {
  border-bottom: 2px solid blue;
  background-color: rgb(91, 107, 225);
  color: white;
  border-radius: 3px;
}

.tab-content {
  flex: 1;
  padding:0;
  border: 1px solid #ccc;  
  margin: 5px;  
  height: 95%;
  overflow: scroll;
}

.update-info p {
  margin: 0;
  font-size: 14px;
  color: #666;
}

.sh-content{
  display:flex;
  flex-direction: row;  
  height: 100%;
}

.sh_form_parent{
   width: 40%;
}

.sh-form {
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-gap: 2px;
  width: 95%;
  margin: 10px;
  overflow: scroll;
  height: 100%;
}

.sh-form .form-row {
  display: contents;
}

/* 信息分区：用不同颜色区分基本信息/镇街提交信息/部门审核信息/反馈记录 */
.info-block {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-gap: 2px;
  padding: 6px 8px;
  margin-bottom: 8px;
  border-radius: 4px;
  border-left: 4px solid #cccccc;
}

.block-title {
  grid-column: 1 / -1;
  font-weight: bold;
  font-size: 14px;
  padding: 2px 0 4px 0;
  margin-bottom: 4px;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.15);
}

.block-base {
  background-color: #e8f2fd;
  border-left-color: #409eff;
}

.block-base .block-title {
  color: #1a5fb4;
}

.block-zj {
  background-color: #eaf7ec;
  border-left-color: #52c41a;
}

.block-zj .block-title {
  color: #237804;
}

.block-sh {
  background-color: #fff4e6;
  border-left-color: #fa8c16;
}

.block-sh .block-title {
  color: #ad4e00;
}

.block-record {
  background-color: #f2f2f2;
  border-left-color: #999999;
}

.block-record .block-title {
  color: #555555;
}

.sh-form label,
.sh-form input,
.sh-form select,
.sh-form button{
  margin: 2px;
  font-size: 14px;
  color: #666;
  height: 25px;
}

.sh-pic-content{
    flex:1;
    border: 1px solid #ccc;
    margin: 1px;    
    overflow: scroll;
    height: 100%;
}

.sh-pic-content-button{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 10px;
    border-bottom: 1pt solid #ccc;
    padding: 5px;
}

.sh-text{
  text-align: left;
}

.sh-option-container{
  display: flex;
  flex-direction: column;
}

.preview-image{
    width: auto;
    height: auto;
    margin: 2px;
    border: 1px solid #000;
    object-fit: contain;
    max-width: 95%;
    max-height: 100%;
    cursor: pointer;
}

img.zoomed {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1.2); 
  z-index: 1006;
  max-width: 80vw;
  max-height: 80vh;
}

.zoom-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1005;
}
::-webkit-scrollbar {
    display: none;
}

/* Firefox 浏览器 */
* {
    scrollbar-width: none;
}

/* Internet Explorer 和 Edge 浏览器 */
* {
    -ms-overflow-style: none;
}

.button-group{
    display:flex;
    font-size: 16px;
    border-bottom: 1px solid #ccc;
    padding: 5px;
    margin: 5px;
}

.button-group label,
.button-group input,
.button-group button{
  margin-right: 3px;
}

.table-header {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1005;
  border: 1px solid #ccc; /* 添加水平表格边框 */  
}

::v-deep .el-table .highlight {
  background-color: rgb(80, 80, 215);
  cursor: pointer;
  opacity: 0.9·;
  color:white;
  z-index: 1011;
}

.table-form{
  overflow: scroll;  
  height: 48vh;
}

.table-content{
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: auto;
}

.tab-content th,
.tab-content td{
  border: 1px solid #CCC; /* 添加水平表格边框 */  
}


</style>